var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}}),_c('div',{staticClass:"BaseImage__Container"},[_c('div',{staticClass:"BaseImage__Background",style:(_vm.customStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }